import { P2GCheckBoxLegacy } from '@parcel2go/core-ui';
import React from 'react';
import ECommerceLogo from '~/apps/account-linking/components/ECommerceLogo';

export const IntegrationRow = ({
  i,
  integrationSelection,
  setIntergrationSelection,
  done
}: {
  i: { slug: string; name: string };
  integrationSelection: string[];
  done?: boolean;
  setIntergrationSelection: React.Dispatch<React.SetStateAction<string[]>>;
}) => {
  const onClick = () => {
    if (!done) {
      setIntergrationSelection((prev) =>
        prev.includes(i.slug) ? prev.filter((x) => x !== i.slug) : [...prev, i.slug]
      );
    }
  };

  return (
    <P2GCheckBoxLegacy
      onChange={onClick}
      disabled={done}
      checked={integrationSelection.includes(i.slug) || done}
      id={'integration-' + i.slug}
      label={<ECommerceLogo integration={i.slug} style={{ height: '50px', maxWidth: '100%' }} />}
    />
  );
};
